import { AdminReservationDto, AdminShowInformationDto } from '../models/admin-api.model';

export type UiReservationStatus = 'Bestätigt' | 'Storniert' | 'Umgebucht';
export type UiReservationSource = 'Web' | 'Kasse' | 'Admin';

export function mapReservationStatus(reservation: AdminReservationDto): UiReservationStatus {
  if (reservation.wasCancelled) {
    return 'Storniert';
  }

  if (reservation.rebookedByAdminAt) {
    return 'Umgebucht';
  }

  return 'Bestätigt';
}

export function mapReservationSource(source: number | null | undefined): UiReservationSource {
  switch (source) {
    case 0:
      return 'Web';
    case 1:
      return 'Kasse';
    case 2:
      return 'Admin';
    default:
      return 'Web';
  }
}

export function mapSlotLabel(slot: number | null | undefined): string {
  switch (slot) {
    case 0:
      return 'Vor der Show';
    case 1:
      return 'Pause';
    case 2:
      return 'Nach der Show';
    default:
      return '—';
  }
}

export function normalizeTime(value: string | null | undefined): string {
  if (!value) {
    return '—';
  }

  return value.slice(0, 5);
}

export function mapSlotTimeRange(
  slot: number | null | undefined,
  show: AdminShowInformationDto
): string {
  switch (slot) {
    case 0:
      return `${normalizeTime(show.incomingTime)}–${normalizeTime(show.showTime)}`;
    case 1:
      return `${normalizeTime(show.intervalStartTime)}–${normalizeTime(show.intervalEndTime)}`;
    case 2:
      return `${normalizeTime(show.showTime)}–${normalizeTime(show.postShowTime)}`;
    default:
      return '—';
  }
}

export function extractShowBlocks(show: AdminShowInformationDto): string[] {
  const blocks: string[] = [];

  if (show.bookingBeforeShow) {
    blocks.push('Vor der Show');
  }

  if (show.bookingPauseShow) {
    blocks.push('Pause');
  }

  if (show.bookingPostShow) {
    blocks.push('Nach der Show');
  }

  return blocks;
}